import React from 'react';
import { GiveawayGoodieSteps } from 'swag-common/interfaces';
import { GiveawayProductsList } from '../giveaway-products-list';
import { GiveawayShippingForm } from '../giveaway-shipping-form';
import { CheckoutProductsList } from '../checkout-products-list';
import { GiveawayLandingSubtitle } from '../giveaway-landing-subtitle';
import { GiveawayLandingCatalogSubtitle } from '../giveaway-landing-catalog-subtitle';
import { GiveawayLandingGoodieCatalog } from '../giveaway-landing-goodie-catalog';
import { GiveawayLandingGoodieCategories, GoodieGiveawayTabsSelect } from '../giveaway-landing-goodie-categories';
import { GiveawayLandingGoodieSelectedProducts } from '../giveaway-landing-goodie-selected-products';
import classes from './giveaway-landing-body.scss';
export const GiveawayLandingBody = ({
  step
}) => {
  switch (step) {
    case GiveawayGoodieSteps.checkout:
      {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GiveawayLandingSubtitle, null, "Here are the products you have selected!"), /*#__PURE__*/React.createElement(CheckoutProductsList, null), /*#__PURE__*/React.createElement(GiveawayShippingForm, null));
      }
    case GiveawayGoodieSteps.catalog:
      {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GiveawayLandingCatalogSubtitle, null), /*#__PURE__*/React.createElement(GiveawayLandingGoodieSelectedProducts, null), /*#__PURE__*/React.createElement("div", {
          className: classes.catalog
        }, /*#__PURE__*/React.createElement(GiveawayLandingGoodieCategories, {
          isFixed: true
        }), /*#__PURE__*/React.createElement(GoodieGiveawayTabsSelect, {
          isFixed: true
        }), /*#__PURE__*/React.createElement(GiveawayLandingGoodieCatalog, {
          isFixed: true,
          wrapperClassName: classes.products
        })));
      }
    default:
      {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GiveawayProductsList, null), /*#__PURE__*/React.createElement(GiveawayShippingForm, null));
      }
  }
};